import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../Home/Home";
import NewAbout from "../NewAbout/NewAbout";
import Services from "../Services/New_Services";
import Why_Us from "../Why_Us/Why_Us";
import Process from "../Process/Process";
import Job_Requirement from "../Job_Requirement/Job_Requirement";
import Contact_Us from "../Contact_Us/Contact_Us";
import Apply_Now from "../apply_now/Apply_Now";

function NewRoutes() {
  return (
    <Routes>
      <Route path="/new/home" element={<Home />} />
      <Route path="/new/newabout" element={<NewAbout />} />
      <Route path="/new/services" element={<Services />} />
      <Route path="/new/why_us" element={<Why_Us />} />
      <Route path="/new/process" element={<Process />} />
      <Route path="/new/job_requirement" element={<Job_Requirement />} />
      <Route path="/new/contact_us" element={<Contact_Us />} />
      <Route path="/new/apply_now" element={<Apply_Now />} />
    </Routes>
  );
}

export default NewRoutes;
